const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de cancelación de ordenes',
  PAGE_DESCRIPTION: 'En este apartado ver las cancelaciones en pendientes.',
  DELIVERY_MISSING_INFO_MESSAGE: 'Información de orden faltante',
  DELIVERY_CANCEL_INSTRUCTIONS:
    'Por favor contacta soporte para que gestione la cancelación de guía de rastreo.',
  DEFAULT_SIMPLE_ORDER_DETAILS_COLUMNS: [
    {
      name: 'name',
      label: 'Nombre del producto'
    },
    {
      name: 'sku',
      label: 'SKU'
    },
    {
      name: 'quantity',
      label: 'cantidad en orden'
    },
    {
      name: 'stored',
      label: 'Cantidad almacenada'
    }
  ]
};

export default HELPER_TEXTS;
